import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

if (process.env.NODE_ENV === "development") {
  const root = ReactDOM.createRoot(document.getElementById('jojokcreator_picturetable'));
  root.render(

    <App settings={{ url: "https://docs.google.com/spreadsheets/d/159Wonfz6EK9ynigYrd8F3UC7OuhcZPOgW7t_uVVY7s8/gviz/tq?", title: "local" }} />
  );
} else {
  const targets = document.querySelectorAll('#jojokcreator_picturetable');

  Array.prototype.forEach.call(targets, target => {
    const id = target.dataset.id;
    const settings = window.erwSettings[id];
    const root = ReactDOM.createRoot(document.getElementById('jojokcreator_picturetable'));
    root.render(

      <App settings={settings} />
    );
  });
}

// // If you want to start measuring performance in your app, pass a function
// // to log results (for example: reportWebVitals(console.log))
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
